import { Stack } from '@mantine/core';
import { ReactNode } from 'react';
import { GenericErrorPage } from 'src/error/GenericErrorPage';
import PageLoader from 'src/UI/loader/PageLoader';
import { EntityFormContext } from '../EntityFormProvider';
import { useEntitySectionForm } from '../hooks/useEntitySectionForm';
import { IndividualSectionCard } from './IndividualSectionCard';

type Props = {
  title: string;
  children: ReactNode;
};

export default function IndividualEntityForm({ title, children }: Props) {
  const {
    form,
    isEditing,
    toggleEditing,
    handleSubmit,
    contextValue,
    nonFinancialData,
    isLoading,
    isError,
    isInitialized,
  } = useEntitySectionForm();

  if (isLoading || !isInitialized) {
    return <PageLoader absolute={false} />;
  }
  if (isError || !nonFinancialData || !contextValue) {
    return <GenericErrorPage error={{ isError, nonFinancialData }} />;
  }

  return (
    <form role="form" onSubmit={form.onSubmit(handleSubmit)}>
      <EntityFormContext value={contextValue}>
        <IndividualSectionCard
          title={title}
          isEditing={isEditing}
          onToggleEdit={toggleEditing}
          canSave={form.isDirty()}
          isSaving={form.submitting}
        >
          <Stack gap="xl">{children}</Stack>
        </IndividualSectionCard>
      </EntityFormContext>
    </form>
  );
}
